import { render, staticRenderFns } from "./contact-box.vue?vue&type=template&id=66be587e"
import script from "./contact-box.vue?vue&type=script&lang=js"
export * from "./contact-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports